import './App.css';
import React, { useEffect } from 'react';

import Nav from "./MyComp/Nav.js";
import Hero from "./MyComp/Hero.js";
import Project from "./MyComp/Project.js";
import About from "./MyComp/About.js";
import Contact from "./MyComp/Contact.js";
import Experience from "./MyComp/Experience.js";
import Footer from "./MyComp/Footer.js";


function App() {
  useEffect(() => {
    const handleResize = () => {
            const tag = document.getElementById('tag');
            const line = document.getElementById('line');
            const tagWidth = tag.offsetWidth;
            const screenWidth = window.innerWidth;
            const marginRightValue = screenWidth - (tag.offsetLeft + tagWidth);
            line.style.paddingRight = marginRightValue + 'px';
    };

    const toggleNav = () => {
      const navButton = document.getElementById('nav-but');
      const navBg = document.getElementById('nav-bg');
      if (navBg.style.height === '100vh') {
          navBg.style.height = '0';
          navButton.innerHTML = '<i class="fa-solid fa-bars"></i>';
          navButton.style.position = 'relative';
      } else {
        console.log('working else!');
          navBg.style.height = '100vh';
          navButton.innerHTML = '<i class="fa-solid fa-circle-xmark"></i>'
          navButton.style.position = 'fixed';
      }
    }

    const sendHire = () => {
            const subject = encodeURIComponent('Employment Opportunity Inquiry');
            const body = encodeURIComponent(
            'Dear Prem,\n\n' +
            'I hope this email finds you well.\n\n' +
            'I am reaching out to express my interest in hiring you for an employment opportunity. Your skills and experience align closely with what we are looking for, and we believe you would be a valuable addition to our team.\n\n' +
            'If you are open to discussing this further, please let me know your availability for a meeting or a discussion.\n\n' +
            'Thank you for considering this opportunity. I look forward to the possibility of working together.\n\n' +
            'Sincerely,\n[Your Name]'
        );
        const email = 'prem12937@gmail.com';
        window.location.href = 'mailto:' + email + '?subject=' + subject + '&body=' + body;
    };

    const projectContainer = document.getElementById('project-container');
    let currentIndex = 0;
    const movePrev = () => {
      currentIndex = (currentIndex === -1) ? 1 : currentIndex - 1;
      projectContainer.style.transform = `translateX(${(-1)*currentIndex * 33}%)`;
    }
    const moveNext = () => {
      currentIndex = (currentIndex === 1) ? -1 : currentIndex + 1;
      projectContainer.style.transform = `translateX(${(-1)*currentIndex * 33}%)`;
    }

    const sendQuery = () => {
      const subject = encodeURIComponent(document.getElementById('cont-subject').value.trim());
      const body = encodeURIComponent(document.getElementById('cont-body').value.trim());
      const email = 'prem12937@example.com';
      window.location.href = 'mailto:' + email + '?subject=' + subject + '&body=' + body;
    }

    const prevBtn = document.getElementById('prev');
    const nextBtn = document.getElementById('next');
    

    document.getElementById('nav-but').addEventListener('click', toggleNav);
    document.getElementById('hire').addEventListener('click', sendHire);
    window.addEventListener('resize', handleResize);
    window.addEventListener('load', handleResize);
    prevBtn.addEventListener('click', movePrev);
    nextBtn.addEventListener('click', moveNext);
    document.getElementById('send').addEventListener('click', sendQuery);
    return () => {
      document.getElementById('nav-but').removeEventListener('click', toggleNav);
      document.getElementById('hire').removeEventListener('click', sendHire);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('load', handleResize);
      prevBtn.removeEventListener('click', movePrev);
      nextBtn.removeEventListener('click', moveNext);
      document.getElementById('send').removeEventListener('click', sendQuery);
    };
  }, []);

  const smoothScroll = (targetId) => {
    const targetElement = document.getElementById(targetId);
    const navButton = document.getElementById('nav-but');
    const navBg = document.getElementById('nav-bg');
    if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
        if (navBg.style.height === '100vh') {
            navBg.style.height = '0';
            navButton.innerHTML = '<i class="fa-solid fa-bars"></i>';
            navButton.style.position = 'relative';
        }
    }
  }

  return (
    <>
    <Nav fun={smoothScroll}/>
    <Hero/>
    <div className="h-48 text-8xl ubun flex items-center justify-center text-zinc-900 whitespace-nowrap bg-gradient-to-r from-cyan-100 to-cyan-600 overflow-hidden">
        <span className="move">• Web Designer • Graphic Designer • Web Developer •</span>
    </div>
    <Project/>
    <About/>
    <Contact/>
    <div className="h-12 bg-gradient-to-r from-zinc-100 to-zinc-300"></div>
    <Experience/>
    <Footer/>
    </>
  );
}


// function smoothScroll(targetId) {
//   const targetElement = document.getElementById(targetId);
//   const navButton = document.getElementById('nav-but');
//   const navBg = document.getElementById('nav-bg');
//   if (targetElement) {
//       targetElement.scrollIntoView({ behavior: 'smooth' });
//       if (navBg.style.height === '100vh') {
//           navBg.style.height = '0';
//           navButton.innerHTML = '<i class="fa-solid fa-bars"></i>';
//           navButton.style.position = 'relative';
//       }
//   }
// }

export default App;
